const styles = (theme) => ({
  container: {
    width: "900px",
    borderRadius: "16px",
    maxWidth: "80vw",
  },
  containerForm: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  containerTitulo: {
    p: 2,
    pb: "4px",
    display: "flex",
    justifyContent: "space-between",
  },
  containerButtons: {
    padding: "10px",
    width: "100%",
    display: "flex",
    justifyContent: "end",
    gap: "10px",
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    borderRadius: "16px",
    height: "300px",
  },
  boxClientes: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },
  containerClientes: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 2,
  },
  titleClientes: { display: "flex", gap: 0.5, alignItems: "center" },
});

export default styles;
